{
	"title": "Learning streak",
	"current": "{days, plural, one {# day} other {# days}}",
	"currentSuffix": "in a row",
	"longest": "Longest",
	"longestValue": "{days, plural, one {# day} other {# days}}",
	"dailyGoal": "Daily goal",
	"dailyGoalValue": "{minutes} min/day",
	"nextMilestone": "{days, plural, one {# day} other {# days}} to next goal",
	"freezes": {
		"title": "Freezes",
		"balance": "{count, plural, one {# freeze} other {# freezes}} in reserve",
		"usedThisWeek": "Used this week: {count}",
		"useManual": "Freeze manually",
		"about": "About freezes",
		"aboutText": "A freeze keeps your streak on a day without study. They're granted automatically (1 per week). If you have a reserve, tap “Freeze manually” to cover a missed day.",
		"none": "No freezes in reserve right now — 1 is granted weekly (on Mondays).",
		"applied": "Freeze applied"
	},
	"heatmap": {
		"title": "Last 30 days",
		"today": "Today",
		"cellMinutes": "{count, plural, one {# min} other {# min}}",
		"frozenCell": "Streak saved by a freeze",
		"legend": {
			"done": "done",
			"frozen": "frozen",
			"missed": "missed"
		}
	},
	"settings": {
		"timezone": "Time zone",
		"reminder": "Reminder",
		"edit": "Edit settings",
		"open": "Open settings"
	},
	"states": {
		"atRiskTitle": "Streak at risk",
		"atRiskBody": "Do at least 1 review or apply a freeze",
		"brokenTitle": "Streak broken",
		"brokenBody": "Previous best: {days, plural, one {# day} other {# days}}. Start a new one — a small daily habit pays off in a week.",
		"milestoneTitle": "Milestone! {days, plural, one {# day} other {# days}} in a row",
		"milestoneBody": "Keep it up."
	},
	"actions": {
		"close": "Close",
		"studyNow": "Study now",
		"share": "Share",
		"continue": "Continue"
	},
	"dialog": {
		"title": "Streak",
		"description": "Keep your learning streak alive",
		"current": "Current",
		"longest": "Longest",
		"dailyGoal": "Daily goal",
		"autoFreeze": "Auto-freeze 1×/week",
		"freezeBalance": "Freezes available: {count}",
		"history30d": "Last 30 days",
		"minutesShort": "{count, plural, one {# min} other {# min}}"
	},
	"banner": {
		"freezeApplied": "Freeze applied in the last week — streak preserved"
	},
	"indicator": {
		"daysLabel": "days",
		"aria": "Learning streak: {days, plural, one {# day} other {# days}}"
	}
}
